import { __assign, __extends, __rest } from "tslib";
import React from "react";
import Checkbox from "./CheckPlat";
import defaultTheme from "../styles/defaultTheme";
/**

 * ## Usage
 * ```js
 * import * as React from 'react';
 * import { Checkbox } from 'pnmac-universal-components';
 *
 * export default class MyComponent extends React.Component {
 *   state = {
 *     checked: false,
 *   };
 *
 *   render() {
 *     const { checked } = this.state;
 *     return (
 *       <Checkbox
 *         status={checked ? 'checked' : 'unchecked'}
 *         onPress={() => { this.setState({ checked: !checked }); }}
 *       />
 *     );
 *   }
 * }
 * ```
 */
var PnmacCheckbox = /** @class */function (_super) {
  __extends(PnmacCheckbox, _super);
  function PnmacCheckbox(props) {
    return _super.call(this, props) || this;
  }
  PnmacCheckbox.prototype.render = function () {
    var rest = __rest(this.props, []);
    return /*#__PURE__*/React.createElement(Checkbox, __assign({}, this.props, {
      nativeID: rest.idTag1
    }));
  };
  return PnmacCheckbox;
}(React.Component);
export default defaultTheme(PnmacCheckbox);